// client/src/i18n.js

import i18n from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, updateDoc, getDoc } from 'firebase/firestore';


// Traductions
const resources = {
    fr: {
        translation: {
            PARAMETRES: "PARAMÈTRES",
            Info: "Informations",
            Email: "Email :",
            Pseudo: "Pseudo :",
            Entreprise: "Entreprise :",
            Désafiliation: "Se désaffilier",
            selectLanguage: "",
            Déconnexion: "Déconnexion",
            Modifier: "Modifier",
            MAJ: "Mettre à jour",
            Invitation: "Invitations en attente",
            Invitation_entreprise: "Cette entreprise vous invite :",
            Accepter: "Accepter",
            Refuser: "Refuser",
            Définir_pseudo: "Définir un pseudo",
            Enregistrer: "Enregistrer",
            Votre_pseudo: "Votre pseudo",
            Nouveau_pseudo: "Nouveau pseudo",
            HISTORIQUE: "HISTORIQUE",



        }
    },

    en: {
        translation: {
            PARAMETRES: "SETTINGS",
            FACTURES: "INVOICES",
    


        }
    },
};

i18n
    .use(LanguageDetector) // Détecte automatiquement la langue du navigateur
    .use(initReactI18next) // Initialise avec React
    .init({
        resources,
        fallbackLng: "fr", // Langue par défaut
        interpolation: {
            escapeValue: false // React gère déjà l'échappement des données
        }
    });

// Composant LanguageSelector
const LanguageSelector = () => {
    const { i18n } = useTranslation(); // Utilisation du hook useTranslation
    const [user, setUser] = useState(null);
    const auth = getAuth();
    const db = getFirestore();
  
    // Récupérer l'utilisateur actuel depuis Firebase et la langue depuis Firestore
    useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
        if (currentUser) {
          setUser(currentUser);
  
          // Récupérer la langue de l'utilisateur depuis Firestore
          const userRef = doc(db, 'users', currentUser.uid);
          const userDoc = await getDoc(userRef);
          
          if (userDoc.exists()) {
            const language = userDoc.data().language || 'fr'; // Langue par défaut si non définie
            i18n.changeLanguage(language); // Appliquer la langue
          }
        }
      });
  
      return () => unsubscribe(); // Nettoyer l'abonnement à l'événement de l'utilisateur
    }, [auth, db, i18n]);
  
    // Fonction pour changer la langue et mettre à jour la base de données
    const handleLanguageChange = async (event) => {
      const newLanguage = event.target.value;
      i18n.changeLanguage(newLanguage); // Change la langue côté client
  
      // Mettre à jour la langue dans la collection users de Firebase
      if (user) {
        try {
          const userRef = doc(db, 'users', user.uid); // Accéder au document de l'utilisateur
          await updateDoc(userRef, {
            language: newLanguage, // Ajouter la langue choisie dans la fiche utilisateur
          });
          console.log('User language updated in Firebase');
        } catch (error) {
          console.error('Error updating language in Firebase', error);
        }
      }
    };
  
    return (
      <div>
        <h3>{i18n.t('selectLanguage')}</h3> {/* Afficher la traduction */}
        <select onChange={handleLanguageChange} defaultValue={i18n.language}>
          <option value="fr">🇫🇷 Français</option>
        </select>
      </div>
    );
  };
  
  // Exportez `LanguageSelector`
  export { LanguageSelector };
  
  export default i18n;